import React, { useState } from 'react';

import { EditOutlined } from '@ant-design/icons';
import { Button, Form, Input, Modal } from 'antd';
import { toast } from 'react-toastify';
import { Organization } from 'src/interfaces/entities/organization';
import { useEditOrganizationMutation } from 'src/redux/services/centralApi';
import { User } from 'src/interfaces/entities/user';

interface IEditOrganizationForm {
	name: string;
}

export default function EditOrganization(
	{
		row,
	}: { row: Organization & { users: User[], jwt: string }}
) {
	const [ open, setOpen, ] = useState<boolean>(false);

	const [ patchOrganization, patchOrganizationResult, ] = useEditOrganizationMutation();

	const [ editOrganizationForm, ] = Form.useForm<IEditOrganizationForm>();

	const onFinishEditOrganizationForm = (data: IEditOrganizationForm) => {
		patchOrganization({
			id: row.id,
			body: {
				name: data.name,
			},
		})
			.unwrap()
			.then(() => {
				toast.success('Organização atualizado com sucesso!', {
					autoClose: 1000,
				});
			})
			.catch((err) => {
				if (err?.status && err?.status === 500
					&& err?.data?.frontend_message) {
					toast.error(err?.data?.frontend_message, {
						autoClose: 1000,
					});
				}
			})
			.finally(() => {
				setOpen(false);
				editOrganizationForm.resetFields();
			});
	};

	return <>
		<Button
			type="text"
			icon={<EditOutlined />}
			onClick={() => setOpen(true)}
		/>
		<Modal
			centered
			title={'Editar Organização'}
			open={open}
			onCancel={() => {
				setOpen(false);
				toast.info('Operação cancelada!', { autoClose: 1000, });
			}}
			destroyOnHidden
			confirmLoading={patchOrganizationResult.isLoading}
			okText="Salvar"
			onOk={() => {
				editOrganizationForm.submit();
			}}
		>
			<Form
				layout="vertical"
				onFinish={onFinishEditOrganizationForm}
				form={editOrganizationForm}
				style={{ marginTop: 10, }}
			>
				<Form.Item
					initialValue={row.name}
					name={'name'}
					hasFeedback
					required
					tooltip={'Insira o nome da organização.'}
					label={'Nome da organização'}
					rules={[
						{
							required: true,
							message: 'Campo obrigatório.',
						},
					]}
				>
					<Input
						defaultValue={row.name}
						placeholder="Nome da organização"
					/>
				</Form.Item>
			</Form>
		</Modal>
	</>;
}